 
import { useState } from "react";
import axios from "axios";
import { message } from "antd";
import { getCurrentUser } from "./getProfile";
import { base_url } from "./helper";

 

export const request = (url = "", method = "get", data = {}) => {
  const headers =
    data instanceof FormData
      ? { "Content-Type": "multipart/form-data; charset=UTF-8" }
      : { "Content-Type": "application/json; charset=UTF-8" };

  // token may be stored with surrounding quotes (e.g. JSON.stringify(token)); normalize it
  const rawToken = localStorage.getItem("token");
  const access_token = rawToken ? String(rawToken).replace(/^"|"$/g, '') : null;
    console.debug('HTTP request', { url: base_url + url, method, hasToken: !!access_token });

  return axios({
    url: base_url + url,
    method: method,
    data: data,
    headers: {
      ...headers,
      Authorization: access_token ? `Bearer ${access_token}` : undefined,
    },
  })
    .then((res) => {
      console.log("Response:", res.data); // Log response data for debugging
      return res.data;
    })
    .catch((error) => {
      console.error("Request failed:", error); // Log error details for debugging
      const status = error.response?.status;

      if (status === 401) {
        message.warning("Your session has expired, please log in again", () => {
          localStorage.clear();
          window.location.href = "/login";
        });
      } else if (status === 403) {
        message.warning("You don't have permission to access this page");
      } else if (status === 404) {
        console.log("Page not found");
      } else if (status === 500) {
        console.log("Server error  status code: 500");
      } else {
        console.log(error);
      }
    });
};

export const getMasterGroups = async () => {
  const param = new URLSearchParams({ org_code: getCurrentUser().org_code });

  const res = await request("usermastergroup?" + param.toString(), "get", {});
  if (res) {
    return res.list_api_master_group[0]; // Changed to return the result directly
  }
};
